import { parseDataAttributes } from '../../utilities/utilities'

export type UserMenuItem = {
  title: string
  url: string
}

export type UserMenuAttributes = {
  menuItems?: UserMenuItem[]
}

function isUserMenuItem(item: unknown): item is UserMenuItem {
  if (!item || typeof item !== 'object') return false
  const record = item as Record<string, unknown>
  const title = record.title
  const url = record.url
  return typeof title === 'string' && typeof url === 'string'
}

/**
 * Parse menuItems from data attribute (may be JSON string or already parsed array).
 */
function parseMenuItems(value: unknown): UserMenuItem[] {
  if (Array.isArray(value)) {
    return value.filter((item): item is UserMenuItem => isUserMenuItem(item))
  }
  if (typeof value === 'string' && value.trim().startsWith('[')) {
    try {
      const parsed: unknown = JSON.parse(value)
      return parseMenuItems(parsed)
    } catch {
      return []
    }
  }
  return []
}

export function getUserMenuAttributes(attrs: NamedNodeMap): UserMenuAttributes {
  const base = parseDataAttributes(attrs)
  const menuItems = parseMenuItems(base.menuItems)

  return {
    menuItems,
  }
}

export default function propsFn(dataAttributes: NamedNodeMap): UserMenuAttributes {
  return getUserMenuAttributes(dataAttributes)
}
